import { withFinancialMetricsAccess } from "@crm-src/components/page-permission-guard"
import { useState, useEffect } from "react"
import { Box } from "@mui/material"
import { usePermissions } from "@crm-src/hooks/usePermissions"
import { financialApi } from "@crm-src/lib/api"
import { useToast } from "@crm-src/hooks/use-toast"
import { FinancialOverview, PeriodType } from "@crm-src/types/financial-metrics"
import { FinancialOverviewTab } from "@crm-src/components/financial-metrics/financial-overview-tab"
import { useSearchParams } from "react-router-dom";

function CompanyOverallPage() {
  const [searchParams] = useSearchParams()
  const periodParam = searchParams.get('period') as PeriodType || '1M'
  
  const [period] = useState<PeriodType>(periodParam)
  const [overviewData, setOverviewData] = useState<FinancialOverview | null>(null)
  const [isLoadingOverview, setIsLoadingOverview] = useState(true)
  
  const { canAccessAdmin } = usePermissions()
  const { toast } = useToast()
  const isAdmin = canAccessAdmin()

  // Load overview data for admin
  useEffect(() => {
    if (isAdmin) {
      loadOverviewData()
    }
  }, [period, isAdmin])

  const loadOverviewData = async () => {
    try {
      setIsLoadingOverview(true)
      const response = await financialApi.getOverview({ period })
      setOverviewData(response.data)
    } catch (error: any) {
      console.error('Error loading overview:', error)
      toast({
        title: "Error",
        description: error.response?.data?.error || "Failed to load financial overview",
        variant: "destructive",
      })
    } finally {
      setIsLoadingOverview(false)
    }
  }

  if (!isAdmin) {
    return null
  }

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 3, mt: 3 }}>
      {overviewData && (
        <FinancialOverviewTab
          data={overviewData}
          isLoading={isLoadingOverview}
        />
      )}
    </Box>
  )
}

export default withFinancialMetricsAccess(CompanyOverallPage)



